import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/main.css'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'



const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(store);
app.use(router);
app.use(ElementPlus);
app.mount('#app'); 